import React, { FC } from 'react';
import styled from 'styled-components';
import { COLORS } from '../../constants';

interface UpdatesBurgerProps {
  children: React.ReactNode;
  onClick?: () => void;
}

export const UpdatesBurger: FC<UpdatesBurgerProps> = ({
  children,
  onClick,
}) => {
  return (
    <UpdatesBurgerContainer onClick={onClick}>
      {children}
    </UpdatesBurgerContainer>
  );
};

const UpdatesBurgerContainer = styled.div`
  background-color: ${COLORS.WHITE};
  padding: 24px;
  width: 100%;
  max-width: 488px;
  box-sizing: border-box;
`;
